/* eslint-disable import/no-anonymous-default-export */
export default (approvedInvestment = [], action) => {
  switch (action.type) {
    case "GET_UNDEFINED_APPROVED_INVESTMENTS":
      return action.payload;
    default:
      return approvedInvestment;
  }
};
